import { type QSetQuestion } from '@exam-management/qset-management';

export function findDifferenceQSetQuestions(
  qSetQuestions: QSetQuestion[],
  previousQSetQuestions: QSetQuestion[],
) {
  return qSetQuestions.filter((qSetQuestion) => {
    const existingQuestion = previousQSetQuestions?.find(
      (qSetQuestionInList) => qSetQuestionInList.id === qSetQuestion.id,
    );
    return !existingQuestion || existingQuestion.questionRefCode !== qSetQuestion.questionRefCode;
  });
}

export function replaceQSetQuestionsWithNewQuestions<T extends { id: string }>(
  oldQSetQuestions: T[],
  newQSetQuestions: T[],
) {
  return oldQSetQuestions.map((obj) => newQSetQuestions.find((diff) => diff.id === obj.id) || obj);
}

export function concatWithUniqueQSetQuestions<T extends { id: string }>(
  originalQSetQuestions: T[],
  newQSetQuestions: T[],
) {
  return originalQSetQuestions.concat(
    newQSetQuestions.filter((diff) => !originalQSetQuestions.some((obj) => obj.id === diff.id)),
  );
}
